export default "__VITE_ASSET__t6r8Gxq5__"